import React, { useState } from 'react';
import cn from 'classnames';

import { getSubscriptionPlans } from "../../../../common/utils/config";
import Button from "../../../../common/components/Button";
import request from "../../../../common/utils/request";
import Processing from "../UI/Processing";
import Error from "../UI/Error";
import Info from "../UI/Info";

export default function SubscriptionForm({ subscription_plan, stripe }) {
  const [currentPlan, setCurrentPlan] = useState(subscription_plan);
  const [plan, setPlan] = useState(subscription_plan);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');

  const plans = getSubscriptionPlans().filter(subscription => subscription.active || currentPlan === subscription.plan);

  const isApplyNotAvailable = () => { return plan == currentPlan; };

  const labelStyles = (subscription) => {
    return cn("plan-selection-dpp_col", {
      'plan-selection_col': currentPlan != subscription.plan,
      'plan-selection-current_col': currentPlan === subscription.plan,
      '-archived': !subscription.active,
    });
  };

  const handleError = (response) => {
    setError('Something went wrong. Please, reload page.');
    setLoading(false);
  };

  const change_completed = (newPlan) => {
    setLoading(false);
    const planDetails = plans.find(
        element => element.plan === newPlan,
    );
    if (!planDetails) {
      return null;
    }
    if(planDetails.period_type === 'monthly'){
      setInfo(
          'Change complete. You have been moved onto the monthly plan ' +
          'and will be charged £29 on your next billing cycle, which is when your annual plan ends.');
    } else {
      setInfo('Change complete. ' +
          'You have been moved onto the annual plan and your account has been debited.' +
          ' If you are mid way through your month, a further discount has been applied.');
    }

  };

  const handleSuccess = (response) => {
    switch(response.status) {
      case 'requires_action':
        stripe.confirmCardPayment(response.client_secret).then((result) => {
          if (result.error) {
            setError(result.error.message);
            setLoading(false);
          } else {
            setCurrentPlan(plan);
            change_completed(plan);
          }
        });
        break;
      case 'fail':
        setError(response.error);
        setLoading(false);
        break;
      default: // 'active'
        setCurrentPlan(plan);
        change_completed(plan);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setInfo('');

    request('put', '/api/subscriptions', { plan: plan })
      .then(handleSuccess)
      .catch(handleError);
  };

  const currentArchivedPlan = plans.filter(plan => plan.plan === currentPlan && !plan.active)[0];

  return (
    <div className="form">
      { currentArchivedPlan && (
        <div className="form-group row -plan-selection_warning">
          <div className="plan-section_warning-note" plan-section>
            <span>You will automatically be moved to the new cheaper plan at the end of you billing cycle.</span>
          </div>
        </div>
      )}
      <div className="form-group row" align="center">
        {plans.map((subscription) => (
          <div className="plan-selection-dpp" key={subscription.plan} >
            <input
              checked={plan == subscription.plan}
              onChange={() => {
                setPlan(subscription.plan);
              }}
              type="radio"
              name="subscription"
              id={`subscription_${subscription.plan}`}
              value="student"
              className="plan-selection_input"
              disabled={loading}
            />
            <label className={labelStyles(subscription)} htmlFor={`subscription_${subscription.plan}`}>
              <div className="plan-section_inset">
                {subscription.active && subscription.period_type === 'annually' && (
                    <div className="plan-selection_ribbon">
                      SAVE 14%
                      <br />
                      £25 per month
                    </div>
                )}
                {!subscription.active && (
                  <div className="plan-selection_ribbon -archived">
                    ENDING
                  </div>
                )}
                <div className="plan-selection_title">{subscription.text}</div>
                <div className="plan-selection_price">{subscription.price_text}</div>
                <div className="plan-selection_period"> {/*{subscription.period}*/} </div>
                <div className="plan-selection_description">
                  {subscription.description}
                  <br/>
                  {subscription.description_2 &&(
                      <span className="strong-description">
                       { subscription.description_2 }
                    </span>)
                  }
                </div>
                <div
                  className={cn(
                    'plan-selection_check',
                    { '-checked': currentPlan === subscription.plan || plan === subscription.plan,
                      '-upgrade': currentPlan != subscription.plan && plan === subscription.plan,
                      '-archived': !subscription.active },
                  )}
                >
                  {(currentPlan === subscription.plan || plan === subscription.plan) && (
                    <div className={cn("plan-selection_check-icon", { "-checked": plan === subscription.plan })} >
                      <svg width="19" height="16">
                        <use xlinkHref="#icon-check-squared" xmlnsXlink="http://www.w3.org/1999/xlink" />
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            </label>
          </div>
        ))}
      </div>

      <div className="form-group row -submit-row" align="center">
        <Button
          type="submit"
          className="-primary"
          disabled={loading || isApplyNotAvailable()}
          onClick={handleSubmit}
        >
          Change Plan
        </Button>
      </div>

      {loading &&
      <Processing />
      }

      {error &&
      <Error error={error} />
      }

      {info &&
      <Info info={info} />
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/Subscription/Form.js